import { gql } from '@apollo/client';

export const GET_RESIDENCES_QUERY = gql`
  query get_data($take: Int!, $skip: Int!, $filters: MtpBuildingFilterInput!) {
    data: mtpBuildings(order: { countBedsFree: DESC }, take: $take, skip: $skip, where: $filters) {
      totalCount
      items {
        id
        files {
          id
          filePath
        }
        settlement {
          id
          name
          category
          community {
            id
            name
          }
          district {
            id
            name
            region {
              id
              name
            }
          }
        }
        updatedAt
        createdAt
        countBedsTotal
        countBedsFree
        countRoomsFree
        countRoomsPetsFree
        countBedsLowMobilityFree
        countBedsTwoStory
        tenancyType
        
        hasKitchen
        hasBathroom
        hasFamilyRooms
        hasFemaleRooms
        hasMaleRooms
        hasWc
        hasElevator
      }
    }
  }
`;

export const GET_SETTLEMENT_WITH_SEARCH_STRING_COUNT_QUERY = gql`
  query get_settlement_count($searchString: String!) {
    data: settlements(
      where: { name: { like: $searchString } }
      order: { category: ASC, name: ASC }
      take: 1
    ) {
      totalCount
    }
  }
`;

export const GET_SETTLEMENT_WITH_SEARCH_STRING_QUERY = gql`
  query get_settlements($skip: Int!, $take: Int!, $searchString: String!) {
    data: settlements(
      where: { name: { like: $searchString } }
      order: { category: ASC, name: ASC }
      take: $take
      skip: $skip
    ) {
      items {
        id
        name
        category
        community {
          id
          name
        }
        district {
          id
          name
          region {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_SETTLEMENT_BY_ID_QUERY = gql`
  query get_settlements($skip: Int!, $take: Int!, $id: Long!) {
    data: settlements(
      where: { id: { eq: $id } }
      order: { category: ASC, name: ASC }
      take: $take
      skip: $skip
    ) {
      items {
        id
        name
        category
        community {
          id
          name
        }
        district {
          id
          name
          region {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_SETTLEMENT_WITH_SEARCH_STRING_AND_REGION_COUNT_QUERY = gql`
  query get_settlement_count($searchString: String!, $regionId: Long!) {
    data: settlements(
      where: {
        and: [{ name: { like: $searchString } }, { district: { regionId: { eq: $regionId } } }]
      }
      order: { category: ASC, name: ASC }
      take: 1
    ) {
      totalCount
    }
  }
`;

export const GET_SETTLEMENT_WITH_SEARCH_STRING_AND_REGION_QUERY = gql`
  query get_settlements($skip: Int!, $take: Int!, $searchString: String!, $regionId: Long!) {
    data: settlements(
      where: {
        and: [{ name: { like: $searchString } }, { district: { regionId: { eq: $regionId } } }]
      }
      order: { category: ASC, name: ASC }
      take: $take
      skip: $skip
    ) {
      items {
        id
        name
        category
        community {
          id
          name
        }
        district {
          id
          name
          region {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_REGIONS_QUERY = gql`
  query get_regions {
    data: regions(order: { id: ASC },
    take: 1000,
    skip: 0) {
      items {
        id
        name
      }
    }
  }
`;

export const GET_RESIDENCES_WITH_AVAILABLE_PLACES_TOTAL_COUNT = gql`
  query get_data {
    data: mtpBuildings(order: { id: DESC }, where: {
      and: [
        {
          countBedsFree:  {
            gt: 0
          }
        },
        {
          files:  {
            any: true
          } 
        }
      ]
    }) {
      totalCount
    }
  }
`;

export const GET_RESIDENCES_WITH_AVAILABLE_PLACES = gql`
  query get_data($take: Int!, $skip: Int!) {
    data: mtpBuildings(order: { id: DESC }, take: $take, skip: $skip, where: {
      and: [
        {
          countBedsFree:  {
            gt: 0
          }
        },
        {
          files:  {
            any: true
          } 
        }
      ]
    }) {
      items {
        id
        settlement {
          district {
            region {
              id
              name
            }
          }
        }
        countBedsFree
      }
    }
  }
`;

export const GET_PHOTO_CONTENT_QUERY = gql`
  query get_photo_content($id: Long!) {
    data: mtpBuildingFiles(where: { id: { eq: $id } }, take: 1) {
      items {
        fileContent
      }
    }
  }
`;

export const GET_STREET_TYPES_AND_BUILDING_TYPES_QUERY = gql`
  query get_types {
    apartmentTypes: buildingTypes(order: { id: ASC }, take: 1000) {
      items {
        id
        shortName
      }
    }
    streetTypes: streetTypes(order: { id: ASC }, take: 1000) {
      items {
        id
        shortName
      }
    }
  }
`;

export const GET_RESIDENCES_WITH_ID_COUNT_QUERY = gql`
  query get_residences_count($searchStringId: Long!) {
    data: mtpBuildings(
      where: {
        and: [
          { isDeleted: { neq: true } }
          { settlementId: { neq: null } }
          { or: [{ id: { eq: $searchStringId } }] }
        ]
      }
      order: { id: ASC }
      take: 1
    ) {
      totalCount
    }
  }
`;

export const GET_RESIDENCES_WITH_SEARCH_STRING_COUNT_QUERY = gql`
  query get_residences_count($searchString: String!) {
    data: mtpBuildings(
      where: {
        and: [
          { isDeleted: { neq: true } }
          { settlementId: { neq: null } }
          {
            or: [
              { name: { like: $searchString } }
              { mtpOwner: { name: { like: $searchString } } }
              { settlement: { name: { like: $searchString } } }
              { settlement: { community: { name: { like: $searchString } } } }
              { settlement: { district: { name: { like: $searchString } } } }
              { settlement: { district: { region: { name: { like: $searchString } } } } }
            ]
          }
        ]
      }
      order: { id: ASC }
      take: 1
    ) {
      totalCount
    }
  }
`;

export const GET_RESIDENCES_WITH_ID_QUERY = gql`
  query get_residences($skip: Int!, $take: Int!, $searchStringId: Long!) {
    data: mtpBuildings(
      where: {
        and: [
          { isDeleted: { neq: true } }
          { settlementId: { neq: null } }
          { or: [{ id: { eq: $searchStringId } }] }
        ]
      }
      order: { countBedsFree: DESC }
      take: $take
      skip: $skip
    ) {
      items {
        id
        name

        addressStreetType
        addressStreetName
        addressBuildingType
        addressBuildingNumber

        countRoomsTotal
        countRoomsFree
        countBedsTotal
        countBedsFree
        countBedsLowMobilityTotal
        countBedsLowMobilityFree
        countRoomsPetsTotal
        countRoomsPetsFree

        hasWc
        hasBathroom
        hasKitchen

        hasFamilyRooms
        hasFemaleRooms
        hasMaleRooms

        hasElevator

        mtpOwner {
          id
          name
        }

        settlement {
          id
          name
          category
          community {
            id
            name
          }
          district {
            id
            name
            region {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_RESIDENCES_WITH_SEARCH_STRING_QUERY = gql`
  query get_residences($skip: Int!, $take: Int!, $searchString: String!) {
    data: mtpBuildings(
      where: {
        and: [
          { isDeleted: { neq: true } }
          { settlementId: { neq: null } }
          {
            or: [
              { name: { like: $searchString } }
              { mtpOwner: { name: { like: $searchString } } }
              { settlement: { name: { like: $searchString } } }
              { settlement: { community: { name: { like: $searchString } } } }
              { settlement: { district: { name: { like: $searchString } } } }
              { settlement: { district: { region: { name: { like: $searchString } } } } }
            ]
          }
        ]
      }
      order: { countBedsFree: DESC }
      take: $take
      skip: $skip
    ) {
      items {
        id
        name

        addressStreetType
        addressStreetName
        addressBuildingType
        addressBuildingNumber

        countRoomsTotal
        countRoomsFree
        countBedsTotal
        countBedsFree
        countBedsLowMobilityTotal
        countBedsLowMobilityFree
        countRoomsPetsTotal
        countRoomsPetsFree

        hasWc
        hasBathroom
        hasKitchen

        hasFamilyRooms
        hasFemaleRooms
        hasMaleRooms

        hasElevator

        mtpOwner {
          id
          name
        }

        settlement {
          id
          name
          category
          community {
            id
            name
          }
          district {
            id
            name
            region {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_RESIDENCE_FULL_INFO_WITH_ADDRESS_BY_ID_QUERY  = gql`
  query get_residences($residenceId: Long!) {
    data: mtpBuildings(
      where: {
        and: [
          { isDeleted: { neq: true } }
          { settlementId: { neq: null } }
          { id: { eq: $residenceId } }
        ]
      }
      order: { countBedsFree: DESC }
      take: 1
      skip: 0
    ) {
      items {
        id
        name

        addressStreetType
        addressStreetName
        addressBuildingType
        addressBuildingNumber

        countFloors
        countRoomsTotal
        countRoomsFree
        countBedsTotal
        countBedsFree
        countBedsLowMobilityTotal
        countBedsLowMobilityFree
        countRoomsPetsTotal
        countRoomsPetsFree
        tenancyType

        hasWc
        hasBathroom
        hasKitchen

        hasFamilyRooms
        hasFemaleRooms
        hasMaleRooms

        hasElevator
        hasWc
        hasBathroom
        hasKitchen

        countBedsTwoStory
        averageLivingArea

        distanceToKindergarten
        distanceToSchool
        distanceToSchoolBus
        distanceToTransportStop
        distanceToAdminServices
        distanceToShop
        distanceToPostalServices
        distanceToHealthcare
        distanceToEmployment

        files {
          id
          filePath
        }

        createdAt
        updatedAt

        mtpOwner {
          id
          name
        }

        settlement {
          id
          name
          category
          community {
            id
            name
          }
          district {
            id
            name
            region {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_RESIDENCE_FULL_INFO_BY_ID_QUERY = gql`
  query get_residences($residenceId: Long!) {
    data: mtpBuildings(
      where: {
        and: [
          { isDeleted: { neq: true } }
          { settlementId: { neq: null } }
          { id: { eq: $residenceId } }
        ]
      }
      order: { countBedsFree: DESC }
      take: 1
      skip: 0
    ) {
      items {
        id
        name

        countFloors
        countRoomsTotal
        countRoomsFree
        countBedsTotal
        countBedsFree
        countBedsLowMobilityTotal
        countBedsLowMobilityFree
        countRoomsPetsTotal
        countRoomsPetsFree
        tenancyType

        hasWc
        hasBathroom
        hasKitchen

        hasFamilyRooms
        hasFemaleRooms
        hasMaleRooms

        hasElevator
        hasWc
        hasBathroom
        hasKitchen

        countBedsTwoStory
        averageLivingArea

        distanceToKindergarten
        distanceToSchool
        distanceToSchoolBus
        distanceToTransportStop
        distanceToAdminServices
        distanceToShop
        distanceToPostalServices
        distanceToHealthcare
        distanceToEmployment

        files {
          id
          filePath
        }

        createdAt
        updatedAt

        mtpOwner {
          id
          name
        }

        settlement {
          id
          name
          category
          community {
            id
            name
          }
          district {
            id
            name
            region {
              id
              name
            }
          }
        }
      }
    }
  }
`;
